export const stripeConfirmAlipay = ({ stripe, clientSecret, data, }) => {
    return stripe?.confirmAlipayPayment(clientSecret, data, { handleActions: false });
};
